export default {
  'objectStorage.list.title': '对象存储',
  'objectStorage.list.columns.title1': '名称',
  'objectStorage.list.columns.title2': '平台',
  'objectStorage.list.columns.title3': '区域代号（Region）',
  'objectStorage.list.columns.title4': '操作',
  'objectStorage.list.top.title1': '第三方对象存储',
  'objectStorage.list.top.text1': '授权接入，即刻使用',
  'objectStorage.list.top.title2': 'LightCDN对象存储',
  'objectStorage.list.top.text2': '自由搭建，完全掌控',
  'objectStorage.list.top.btnText1': '授权接入',
  'objectStorage.list.top.btnText2': '上线提醒我',
  'objectStorage.list.top.btnText3': '已设置提醒',
  'objectStorage.list.Popconfirm.okText': '是的',
  'objectStorage.list.Popconfirm.cancelText': '取消',
  'objectStorage.list.Popconfirm.cdnText': '前往cdn资源',
  'objectStorage.list.Popconfirm.delText.1': '确认删除 ',
  'objectStorage.list.Popconfirm.delText.2': ' 的对象存储吗？',
  'objectStorage.list.Popconfirm.delNoText.1': '当前还有 ',
  'objectStorage.list.Popconfirm.delNoText.2': ' 个资源使用 ',
  'objectStorage.list.Popconfirm.delNoText.3': '作为源，请更换源后再进行删除',
  'objectStorage.create.btnText': '授权对象存储',
  'objectStorage.create.form.name': '名称',
  'objectStorage.create.form.name.label':
    '（创建时，用于平台区别的空间名称，非第三方的对象存储名称）',
  'objectStorage.create.form.name.message': '请输入正确的名字',
  'objectStorage.create.form.name.rule': '请使用 4-20 字符',
  'objectStorage.create.form.name.placeholder': '请选择已接入的对象存储',
  'objectStorage.create.form.PleaseInput': '请输入',
  'objectStorage.create.form.PleaseSelect': '请选择',
  'objectStorage.create.form.thirdPartyName': '第三方平台',
  'objectStorage.create.form.secretKeyAK': '密钥ID （AK）',
  'objectStorage.create.form.secretKeyAK.message': '请输入正确的密钥ID （AK）',
  'objectStorage.create.form.secretKeySK': '密钥Key （SK）',
  'objectStorage.create.form.secretKeySK.message': '请输入正确的密钥Key （SK）',
  'objectStorage.create.form.secretKeySK.placeholder': '需要重新验证',
  'objectStorage.create.form.regionCode': '区域代号（Region）',
  'objectStorage.create.form.regionCode.placeholder': '例：us-east-2',
  'objectStorage.create.form.regionCode.message': '请输入正确的区域代号',
  'objectStorage.create.form.Endpoint': 'Endpoint（选填）',
  'objectStorage.create.form.Endpoint.placeholder': 'Endpoint域名或URL，只有非AWS应用时才需要填写',
  'objectStorage.create.form.EndpointStyle': 'Endpoint中存储桶访问样式',
  'objectStorage.create.form.access': '获取方式',
  'objectStorage.create.form.StorageSpaceName': '存储空间名称',
  'objectStorage.create.form.StorageSpaceName.placeholder': '例：oss-cn-shanghai.aliyuncs.com',
  'objectStorage.create.form.StorageSpaceName.message': '请输入正确的存储空间名称',
  'objectStorage.create.form.access.tip1': '访问URL：CDNhostname/path/filename',
  'objectStorage.create.form.access.tip2':
    '访问URL：CDNhostname/BUCKET-NAME/path/filename。若你的文件直接存储在对象存储中，可能不存在path。',
  'objectStorage.create.form.document': '点击此处了解如何接入 →',
  'objectStorage.create.form.bucketAddressStyle.1': '路径',
  'objectStorage.create.form.bucketAddressStyle.2': '子域名',
  'objectStorage.create.form.bucketParam.1': '指定存储空间',
  'objectStorage.create.form.bucketParam.2': 'URL前缀/BUCKET-NAME/filename',
  'objectStorage.create.form.name.unique': '名称已存在。',
};
